import React, {Component} from 'react';
import { bindActionCreators } from 'redux';
import {connect} from 'react-redux';
import {updateTillaggForm, getLocalTillaggFrom, updateTillaggFormBanderoll, updateArtcile} from '../../Services/Tillagg/action';

import './style.scss';



class Checkboxes extends Component {
    constructor(props, context) {
		super(props, context);

        this.state = {
            activeRow: false
        }
    }

    checkLocalStorage = () => {
        let localTillaggFrom = localStorage.getItem('tillaggform-welandutemiljo');
        if(localTillaggFrom !== null)
        {
            this.props.getLocalTillaggFrom(JSON.parse(localTillaggFrom));
        }
    }

    componentDidMount = () => {
        this.checkLocalStorage();
    }

    updateCheckBox = (e, index, type, value) => {
        let truefalse;
        if(value)
        {
            truefalse = false;
        }else {
            truefalse = true;
        }
        this.props.updateTillaggForm(index, type, truefalse);
    }
    updateCheckBoxBanderoll = (e, index, type, value) => {
        let truefalse;
        let disable = false;
        if(value)
        {
            truefalse = false;
        }else {
            truefalse = true;
        }

        // console.log(this.props.form.banderoll);
        if(truefalse)
        {
            if(index == 0)
            {
                this.props.form.banderoll[1].disable = false;
            }
        }else {
            if(index == 0)
            {
                this.props.form.banderoll[1].disable = true;
            }
        }
        this.props.updateTillaggFormBanderoll(index, type, truefalse); 
    }

    updateTextarea = (e) => {
        
        let value = e.target.value;
        let name = e.target.name;
        console.log(name);

        this.props.updateArtcile(name, value);


    }


    render = () => {
        const {form} = this.props;
        let textarea;

        if(form.banderoll)
        {
            if(form.banderoll[0].checked){
                textarea = (
                    <div className="field is-horizontal">
                        <div className="field-label">
                            <label className="label"> Lägg till artikelnamn <br/><small style={{fontWeight: "200"}}>Gå vidare till .<a href="https://sandatex.se/produkt-kategori/solskydd-utomhus/markisvav/" style={{color: "#005c9c"}} target="_blank">Sandatex</a> för att se artikelnr, skriv in önskad kulör ex: Markisväv 790.</small></label>
                        </div>
                        <div className="field-body">
                            <div className="field">
                                <div className="control">
                                    <textarea className="textarea" value={form.articles} name="articles" onChange={(e) => this.updateTextarea(e)}></textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        }

        return (
            <div className="hero transparent">
                    <div className="hero-body" style={{paddingTop: '1rem'}}>
                        <div className="container items-container">
                            <div className="field is-horizontal checkboxes">
                                <div className="field-label">
                                    <label className="label"> Önskad färg stativ:</label>
                                </div>
                                <div className="field-body">
                                {
                                    form.stativ.map((value, index) => {
                                        let backgroundImage = value.image;
                                        
                                        return (
                                            <div className="field" key={index}>
                                                <div className="control">
                                                    <label className="checkbox">
                                                    
                                                    <input type="checkbox" checked={value.checked} onChange={(e) => this.updateCheckBox(e, index, 'stativ', value.checked)} /> {value.name}  
                                                    <div className="previewImage" style={{height: '98px', width: '98px', top: '-75px'}}>
                                                        <img src={backgroundImage} />
                                                    </div>
                                                    </label>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                                </div>
                            </div>
                            <div className="field is-horizontal checkboxes">
                                <div className="field-label">
                                    <label className="label"> Önskat stativavslut:</label>
                                </div>
                                <div className="field-body">
                                    {
                                        form.stativavslut.map((value, index) => {
                                            let backgroundImage = value.image;
                                            return (
                                                <div className="field" key={index}>
                                                    <div className="control">
                                                        <label className="checkbox">
                                                        <input type="checkbox" checked={value.checked} onChange={(e) => this.updateCheckBox(e, index, 'stativavslut', value.checked)} /> {value.name}
                                                        <div className="previewImage" style={{height: '98px', width: '98px'}}>
                                                            <img src={backgroundImage} />
                                                        </div>
                                                        </label>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                                    
                                    
                            </div>
                            <div className="field is-horizontal checkboxes">
                                <div className="field-label">
                                    <label className="label"> Banderoll: </label>
                                </div>
                                <div className="field-body">
                                    {
                                        // todo.. 

                                        form.banderoll.map((value, index) => {
                                            let classes;
                                            if(value.disable)
                                            {
                                                 classes = "grey-color";
                                            }else {
                                                classes = "";
                                            }
                                            return (
                                                <div className="field" key={index}>
                                                    <div className="control">
                                                        <label className="checkbox">
                                                        <input type="checkbox" checked={value.checked} disabled={value.disable} onChange={(e) => this.updateCheckBoxBanderoll(e, index, 'banderoll', value.checked)} /> <span className={classes}>{value.name}</span>
                                                        </label>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    
                                    }
                                    
                                    
                                </div>
                            </div>
                            {textarea}
                            <div className="field is-horizontal checkboxes">
                                <div className="field-label">
                                    <label className="label"> Glas: </label>
                                </div>
                                <div className="field-body">
                                    
                                    {
                                        form.glas.map((value, index) => {
                                            return (
                                                <div className="field" key={index}>
                                                    <div className="control">
                                                        <label className="checkbox">
                                                        <input type="checkbox" checked={value.checked} onChange={(e) => this.updateCheckBox(e, index, 'glas', value.checked)} /> {value.name}
                                                        </label>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        )
    }


}
const mapStateToProps = (state) => {
    return {
        form: state.tillagg.tillaggform
    };
};
const mapDispatchToProps = (dispatch) => {
  return {
    updateTillaggForm: bindActionCreators(updateTillaggForm, dispatch),
    getLocalTillaggFrom: bindActionCreators(getLocalTillaggFrom, dispatch),
    updateTillaggFormBanderoll: bindActionCreators(updateTillaggFormBanderoll, dispatch),
    updateArtcile: bindActionCreators(updateArtcile, dispatch)
  };
}; 

export default connect(mapStateToProps, mapDispatchToProps)(Checkboxes);


// WEBPACK FOOTER //
// ./src/Components/Checkboxes/index.js